module.exports = function spriteMapLoader(spritemap) {
    // parse spritemap filename from url
    let spritemapName;

    try {
        spritemapName = spritemap.split('/').pop().split('.')[0];
    } catch (e) {}

    let hasSpritemapNameElements =
        document.querySelector(`[data-spritemap="${spritemapName}"]`) !== null;

    if (spritemapName && hasSpritemapNameElements) {
        return;
    }

    let ajax = new XMLHttpRequest();

    ajax.open('GET', spritemap);
    ajax.responseType = 'document';

    ajax.onload = function (e) {
        let svg = ajax.responseXML.documentElement;

        if (ajax.status === 200) {
            // visually hide spritemap
            svg.style.position = 'absolute';
            svg.style.height = '0px';
            svg.style.width = '0px';
            svg.style.overflow = 'hidden';

            // update attributes before inserting into html
            svg.removeAttribute('xmlns');
            svg.removeAttribute('xmlns:xlink');
            svg.setAttribute('data-spritemap', spritemapName);

            // inject TikTok icon colors
            const tikTokBlue = svg.querySelector('#icon-tiktok #tiktok-blue');
            if (tikTokBlue) {
                tikTokBlue.setAttribute('fill', '#25f4ee');
            }
            const tikTokRed = svg.querySelector('#icon-tiktok #tiktok-red');
            if (tikTokRed) {
                tikTokRed.setAttribute('fill', '#fe2c55');
            }

            // insert spritemap into page
            document.body.insertBefore(svg, document.body.childNodes[0]);
        } else {
            console.error(`Failed to load spritemap at ${spritemap}`, e);
        }
    };
    // initiate ajax request
    ajax.send();
};
